export enum Tabs {
  Tutorial = 'tutorial',
  Rules = 'rules',
}
